// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscribeGym_container__18YD7","subscribeBox":"SubscribeGym_subscribeBox__342EA"};